import BaseAPI from '@/apis/base/baseApi';
class NetworkLocationAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'networkLocation';
}

export default new NetworkLocationAPI();
